module.exports = __webpack_public_path__ + "img/diw_16_Rec.4965d088.png";